export const favorites = {
  title: "Mijn favorieten",
  subtitle: "{{count}} opgeslagen woningen",
  countries: "Landen",
  cities: "Steden",
  emptyTitle: "Nog geen favorieten",
  emptyFiltered: "Probeer uw filters te wijzigen om uw favorieten te zien.",
  emptyState:
    "Ontdek onze unieke woningen en voeg ze toe aan uw favorieten om ze hier terug te vinden.",
  noFavoritesYet: "Nog geen favorieten",
  exploreMembersMap: "Verken de ledenkaart om woningen te vinden",
  exploreMap: "De kaart verkennen",
  backToHome: "Terug naar de startpagina",
  howToAddFavorites: "Hoe favorieten toevoegen?",
  step1: "Ga naar de",
  step2: "ledenkaart",
  step3: "en klik op het hartje",
  step3End: "om een woning aan uw favorieten toe te voegen",
  membersMapLink: "Ledenkaart",
  properties: "woningen",
  selected: "geselecteerd",
  compare: "Vergelijken",
  actions: "Acties",
  contact: "Contact opnemen",
  exchange: "Ruil voorstellen",
  removeFromFavorites: "Uit favorieten verwijderen",
  removeFromComparison: "Uit vergelijking verwijderen",
  owner: "Eigenaar",
  ratingLabel: "Beoordeling",
  exchangesLabel: "Ruilen",
  exchangesCount: "ruilen",
  exchangesCompleted: "gerealiseerde ruilen",
  capacityLabel: "Capaciteit",
  guestsCount: "reizigers",
  numberOfRooms: "slaapkamers",
  roomsCount: "slaapkamers",
  onlineStatus: "Verbonden",
  onlineBadge: "Verbonden",
  verifiedStatus: "Geverifieerd",
  verifiedBadge: "Geverifieerd",
  no: "Nee",
};
